import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{attrs:{"elevation":_vm.elevation,"icon":"","color":_vm.color},on:{"click":_vm.onDelete}},[_c('span',{staticClass:"d-sr-only-focusable"},[_vm._v(" "+_vm._s(_vm.$t("Delete")))]),_c(VIcon,{attrs:{"medium":""}},[_vm._v("mdi-delete")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }